<template>
  <div class="container-fluid">
    <section-title
      has-line
      content="Información de General"
      :class="isMobile ? 'section-title' : ''"
    />

    <ValidationProvider v-slot="{ errors }" rules="required">
      <div class="row bg-secondary-9 mx-0 rounded">
        <div class="col-12 d-flex p-0">
          <div class="bg-secondary-5 p-3 rounded-left">
            <label class="mb-0 color-gray-6" for="centralLevel">
              Tipo de Nivel:
            </label>
          </div>
          <div class="bg-secondary-9 p-3 rounded-right">
            <custom-radio-button
              v-model="value.levelTypeId"
              class="central-levels"
              name="centralLevel"
              label=""
              :options="radioButtonsOptionsLevelType"
              is-inline
              :error="errors[0]"
              custom-error-msg=""
              :is-disabled="readonly"
              @input="resetForm"
            />
          </div>
        </div>
      </div>
      <CustomError
        v-if="errors[0]"
        variant="no-border"
        message="El tipo de nivel es requerido."
      />
    </ValidationProvider>

    <div v-if="isCenterLevel">
      <div
        :class="[
          'row d-flex justify-content-start',
          { 'mt-4': !isMobile, 'mt-3': isMobile },
        ]"
      >
        <div :class="['col-md-4 col-12', { 'mt-3': isMobile }]">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="value.center"
              :options="collections.centers"
              label="Centro:"
              :regular-label="isMobile"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="height-fixed"
              :error="errors[0]"
              custom-error-msg="El centro es requerido."
              :disabled="readonly && formFieldsCompleted"
            />
          </ValidationProvider>
        </div>
      </div>
    </div>

    <div v-if="isSchoolLevel">
      <div
        :class="[
          'row d-flex justify-content-start',
          { 'mt-4': !isMobile, 'mt-3': isMobile },
        ]"
      >
        <div class="col-md-4 col-12">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="ddlRegionType"
              v-model="value.region"
              :options="collections.regions"
              :disabled="
                (isDropDownRegionDisabled || readonly) && formFieldsCompleted
              "
              label="Región:"
              :regular-label="isMobile"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="height-fixed"
              :error="errors[0]"
              custom-error-msg="La región es requerida."
              @input="onChangeRegion"
            />
          </ValidationProvider>
        </div>

        <div class="col-md-4 col-12">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="ddlMunicipality"
              v-model="value.municipality"
              :options="collections.municipalities"
              :disabled="
                (isDropDownMunicipalityIdDisabled || readonly) &&
                  formFieldsCompleted
              "
              label="Municipio:"
              :regular-label="isMobile"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="height-fixed"
              :error="errors[0]"
              custom-error-msg="El municipio es requerido."
              @input="onChangeMunicipality"
            />
          </ValidationProvider>
        </div>

        <div :class="['col-12 col-md-4', { 'mt-3': isMobile }]">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="ddlSchool"
              v-model="value.school"
              :options="collections.schools"
              :disabled="
                (isDropDownSchoolDisabled || readonly) && formFieldsCompleted
              "
              label="Escuela:"
              :regular-label="isMobile"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="height-fixed"
              :error="errors[0]"
              custom-error-msg="La escuela es requerida."
              @input="onChangeSchool"
            />
          </ValidationProvider>
        </div>
      </div>

      <div
        :class="[
          'row d-flex justify-content-start',
          { 'mt-4': !isMobile, 'mt-3': isMobile },
        ]"
      >
        <div :class="['col-md-4 col-12', { 'mt-3': isMobile }]">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              key="school"
              v-model="value.classroom"
              :options="classroomTypes"
              label="Tipo de salón:"
              :regular-label="isMobile"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="height-fixed"
              :error="errors[0]"
              custom-error-msg="El tipo de salón es requerido."
              :disabled="readonly && formFieldsCompleted"
            />
          </ValidationProvider>
        </div>

        <div :class="['col-md-4 col-12', { 'mt-3': isMobile }]">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="ddlPhysicalSchool"
              v-model="value.custodian"
              :options="collections.custodians"
              label="Nombre del maestro:"
              :regular-label="isMobile"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="height-fixed"
              :error="errors[0]"
              custom-error-msg="El nombre del(la) maestro(a) es requerido."
              :disabled="
                (isDropDownCustodianDisabled || readonly) && formFieldsCompleted
              "
              @input="onChangeCustodian"
            />
          </ValidationProvider>
        </div>
        <div class="col-md-4 col-12">
          <ValidationProvider
            v-slot="{ errors }"
            :rules="requiredCustodianName ? 'required' : ''"
          >
            <CustomInput
              v-if="requiredCustodianName"
              v-model="value.custodianName"
              class="height-fixed"
              label="Otro:"
              type="text"
              :error="errors[0]"
              custom-error-msg="Favor escriba el nombre del maestro."
              :disabled="readonly"
            />
          </ValidationProvider>
        </div>
      </div>

      <div
        :class="[
          'row d-flex justify-content-start',
          { 'mt-4': !isMobile, 'mt-3': isMobile },
        ]"
      >
        <div class="col-md-4 col-12">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <CustomInput
              v-model="value.studentEnrollment"
              label="Matrícula de Estudiante:"
              class="height-fixed"
              type="text"
              :error="errors[0]"
              custom-error-msg="La matricula de estudiantes es requerida."
              :disabled="readonly"
            />
          </ValidationProvider>
        </div>
      </div>

      <div
        :class="[
          'row d-flex justify-content-start section-information',
          { 'mt-4': !isMobile, 'mt-3': isMobile },
        ]"
      >
        <div class="col-md-3 col-12">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-radio-button
              v-model="value.schoolBelongsTo"
              name="schoolBelongsTo"
              label="Escuela pertenece a:"
              :options="radioButtonsOptionsSchoolBelongsTo"
              is-inline
              :error="errors[0]"
              custom-error-msg="Favor seleccione al tipo de escuela que pertenece."
              :is-disabled="readonly"
            />
          </ValidationProvider>
        </div>

        <div class="col-md-4 col-12">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-radio-button
              v-model="value.hasPreviouslySubmitted"
              name="hasPreviouslySubmitted"
              label="¿Han sometido cartas solicitando reparaciones o instalaciones anteriormente?"
              :options="radioButtonsOptionsLetters"
              is-inline
              :error="errors[0]"
              custom-error-msg="Favor contestar sí o no."
              :is-disabled="readonly"
            />
          </ValidationProvider>
        </div>
        <div class="col-md-2 col-12">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-radio-button
              v-model="value.isComplaintRequest"
              name="isComplaintRequest"
              label="¿La solicitud es por una querella?"
              :options="radioButtonsOptionsComplaint"
              is-inline
              :error="errors[0]"
              custom-error-msg="Favor contestar sí o no."
              :is-disabled="readonly"
            />
          </ValidationProvider>
        </div>
        <div class="col-md-2 col-12">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-radio-button
              v-model="value.isNewCreationRequest"
              name="isNewRequest"
              label="¿La escuela es de nueva creación?"
              :options="radioButtonsOptionsNewRequest"
              is-inline
              :error="errors[0]"
              custom-error-msg="Favor contestar sí o no."
              :is-disabled="readonly"
            />
          </ValidationProvider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomRadioButton from 'custom-radio';
import CustomError from 'custom-error';
import schoolMembership from '@/utils/constants/pei/materials-equipment/schoolMembership.js';
import saloons from '@/utils/constants/pei/materials-equipment/saloons.js';
import levelTypes from '@/utils/constants/pei/materials-equipment/levelTypes.js';
import materialsService from '@/services/api/materialsEquipment.api.js';
import childCountService from '@/services/api/childCount.api';
import locationService from '@/services/api/location.api.js';
import { getCurrentAcademicYear } from '@/services/api/tapRequest.api.js';
import CustomInput from 'CustomInput';

export default {
  name: 'SchoolInformation',
  components: {
    SectionTitle,
    CustomDropDown,
    CustomRadioButton,
    CustomInput,
    CustomError,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      radioButtonsOptionsSchoolBelongsTo: [
        { label: 'Omep', value: schoolMembership.Omep },
        {
          label: 'Edificios Públicos',
          value: schoolMembership.EdificiosPublicos,
        },
      ],
      radioButtonsOptionsLetters: [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ],
      radioButtonsOptionsComplaint: [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ],
      radioButtonsOptionsNewRequest: [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ],
      collections: {
        schools: [],
        centers: [],
        custodians: [],
        regions: [],
        municipalities: [],
        classroomTypes: [],
        levelTypes: [],
      },
      formFieldsCompleted: false,
    };
  },
  computed: {
    radioButtonsOptionsLevelType() {
      return this.collections.levelTypes.map((x) => ({
        label: x.name,
        value: x.id,
      }));
    },
    classroomTypes() {
      return this.collections.classroomTypes.filter(
        (classroomType) =>
          !this.classroomTypesToIgnore.includes(classroomType.id)
      );
    },
    classroomTypesToIgnore() {
      const type = !isNaN(this.value.levelTypeId)
        ? parseInt(this.value.levelTypeId)
        : 0;
      switch (type) {
        case levelTypes.CentralLevel:
          return [saloons.Center];
        case levelTypes.School:
          return [saloons.CentralLevel, saloons.Center];
        default:
          return [];
      }
    },
    isCentralLevel() {
      return this.value.levelTypeId == levelTypes.CentralLevel;
    },
    isCenterLevel() {
      return this.value.levelTypeId == levelTypes.Center;
    },
    isSchoolLevel() {
      return this.value.levelTypeId == levelTypes.School;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    isDropDownSchoolDisabled() {
      return this.collections.schools && this.collections.schools.length <= 1;
    },
    isDropDownRegionDisabled() {
      return this.collections.regions && this.collections.regions.length <= 1;
    },
    isDropDownMunicipalityIdDisabled() {
      return (
        this.collections.municipalities &&
        this.collections.municipalities.length <= 1
      );
    },
    isDropDownCustodianDisabled() {
      return (
        this.collections.custodians && this.collections.custodians.length <= 1
      );
    },
    requiredCustodianName: function() {
      return this.value.custodian?.name == 'Otro';
    },
  },
  methods: {
    resetForm() {
      this.$parent.reset && this.$parent.reset();
      const type = !isNaN(this.value.levelTypeId)
        ? parseInt(this.value.levelTypeId)
        : 0;

      if (type == levelTypes.CentralLevel) {
        this.value.classroom = this.collections.classroomTypes.find(
          (x) => x.id == saloons.CentralLevel
        );
        this.value.center = null;
        this.cleanSchool();
      } else if (type == levelTypes.Center) {
        this.value.classroom = this.collections.classroomTypes.find(
          (x) => x.id == saloons.Center
        );
        this.cleanSchool();
      } else {
        this.value.classroom = null;
        this.value.center = null;
      }
    },
    cleanSchool() {
      this.value.region = null;
      this.value.municipality = null;
      this.value.school = null;
      this.value.custodian = null;
      this.value.custodianName = null;
      this.value.studentEnrollment = null;
      this.value.isNewCreationRequest = null;
      this.value.hasPreviouslySubmitted = null;
      this.value.isComplaintRequest = null;
      this.value.schoolBelongsTo = null;
    },
    async getCustodianList(locationSchoolId) {
      const { data } = await childCountService.getSchoolCustodian(
        locationSchoolId
      );
      if (data) {
        this.collections.custodians = data;
        if (
          this.collections.custodians &&
          this.collections.custodians.length == 1
        ) {
          this.value.custodian = this.collections.custodians[0];
        }
      }
      this.collections.custodians.push({ id: 1, name: 'Otro' });
    },
    async onChangeRegion(region) {
      this.value.municipality = null;
      this.value.school = null;
      this.value.custodian = null;
      this.collections.municipalities = [];
      this.collections.schools = [];
      this.collections.custodians = [];
      this.resetForm();
      if (region) {
        await this.fetchMunicipalities(region.id);
      }
    },
    async onChangeMunicipality(municipality) {
      this.value.school = null;
      this.value.custodian = null;
      this.collections.schools = [];
      this.collections.custodians = [];
      this.resetForm();
      if (municipality) {
        await this.fetchSchools(municipality.id);
      }
    },
    async onChangeSchool(school) {
      this.value.custodian = null;
      this.collections.custodians = [];
      this.resetForm();
      if (school) {
        await this.getCustodianList(school.id);
      }
    },
    async onChangeCustodian(custodian) {
      if (custodian.id != 1) {
        this.value.custodianName = null;
      }
    },
    async fetchRegions() {
      const { data } = await locationService.getRegions({
        academicYearId: this.value.academicYearId,
      });
      this.collections.regions = data;
      if (this.collections.regions && this.collections.regions.length == 1) {
        this.value.region = this.collections.regions[0];
        await this.fetchMunicipalities(this.value.region.id);
      }
    },
    async fetchMunicipalities(regionId) {
      const { data } = await locationService.getMunicipalities({
        regionId,
        academicYearId: this.value.academicYearId,
      });
      this.collections.municipalities = data;
      if (
        this.collections.municipalities &&
        this.collections.municipalities.length == 1
      ) {
        this.value.municipality = this.collections.municipalities[0];
        await this.fetchSchools(this.value.municipality.id);
      }
    },
    async fetchSchools(municipalityId) {
      const { data } = await locationService.getSchoolsWithCustodian({
        municipalityId,
        academicYearId: this.value.academicYearId,
      });
      this.collections.schools = data;
      if (this.collections.schools && this.collections.schools.length == 1) {
        this.value.school = this.collections.schools[0];
        await this.getCustodianList(this.value.school.id);
      }
    },
    async fetchCenters() {
      const { data } = await locationService.getCenters({
        academicYearId: this.value.academicYearId,
      });
      this.collections.centers = data;
    },
    async fetchClassroomTypes() {
      const { data } = await materialsService.getSaloonTypes();
      this.collections.classroomTypes = data;
    },
    async fetchLevelTypes() {
      const { data } = await materialsService.getLevelTypes();
      this.collections.levelTypes = data;
    },
    async getCurrentAcademicYear() {
      const { data: academicYear } = await getCurrentAcademicYear();
      this.value.academicYearId = academicYear.id;
    },
    async setFormFields() {
      if (this.isSchoolLevel) {
        this.value.region = this.collections.regions.find(
          (ele) => ele.id == this.value.regionId
        );

        await this.fetchMunicipalities(this.value.regionId);
        this.value.municipality = this.collections.municipalities.find(
          (ele) => ele.id == this.value.municipalityId
        );

        await this.fetchSchools(this.value.municipalityId);
        this.value.school = this.collections.schools.find(
          (ele) => ele.id == this.value.locationSchoolId
        );

        await this.getCustodianList(this.value.locationSchoolId);
        this.value.custodian = this.collections.custodians.find(
          (ele) => ele.id == this.value.custodianId
        );
      }

      this.formFieldsCompleted = true;
    },
  },
  async created() {
    await this.getCurrentAcademicYear();
    await this.fetchRegions();
    await this.fetchClassroomTypes();
    await this.fetchLevelTypes();
    await this.fetchCenters();
    if (this.value.regionId != null && this.value.municipalityId != null) {
      await this.setFormFields();
    }

    if (this.isCenterLevel) {
      this.value.center = this.collections.centers.find(
        (ele) => ele.id == this.value.centerId
      );
    }
    this.value.classroom = this.collections.classroomTypes.find(
      (ele) => ele.id == this.value.classroomTypeId
    );
    this.formFieldsCompleted = true;
  },
};
</script>

<style scoped>
.read-only >>> input {
  pointer-events: none;
  cursor: not-allowed !important;
  background-color: #f8f8f8;
}
.section-information {
  background-color: #f5f5f5;
  margin-left: 0.1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.height-fixed >>> .vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 2px) !important;
}

::v-deep .text-title {
  font-size: 0.75rem !important;
  font-weight: normal !important;
}

::v-deep .central-levels .custom-control.custom-radio {
  margin: 0 70px 0 70px;
}

@media only screen and (max-width: 375px) {
  ::v-deep .regular {
    font-size: 0.75rem !important;
    font-weight: normal !important;
  }

  ::v-deep .tag-badge-title-info {
    font-size: 0.75rem !important;
  }

  .section-title {
    width: 100% !important;
  }

  ::v-deep .input-display {
    font-size: 0.75rem;
  }

  ::v-deep .input-display > label {
    color: #727272 !important;
    font-weight: normal !important;
  }
}
</style>
